import request from '../config/axiosConfig';
import {
  CREATE_MEMBER,
  DELETE_MEMBER,
  GET_ALL_PARTNERS,
  GET_ALL_ROLES,
  GET_LIST_MEMBERS,
  GET_STATUS_ACCOUNT,
  UPDATE_MEMBER,
} from '../constants/apiEndPoint';

export const getListMembersRequest = async (data) => {
  const result = await request({
    url: GET_LIST_MEMBERS,
    method: 'POST',
    data,
  });
  return result?.data?.data;
};

export const createMemberRequest = async (data) => {
  const result = await request({
    url: CREATE_MEMBER,
    method: 'POST',
    data,
  });
  return result?.data;
};

export const updateMemberRequest = async (data) => {
  const result = await request({
    url: UPDATE_MEMBER,
    method: 'POST',
    data,
  });
  return result?.data;
};

export const deleteMemberRequest = async (data) => {
  const result = await request({
    url: DELETE_MEMBER,
    method: 'DELETE',
    data,
  });
  return result?.data;
};

export const getListAllPartnersRequest = async (data) => {
  const result = await request({
    url: GET_ALL_PARTNERS,
    method: 'POST',
    data,
  });
  return result?.data?.data?.data;
};

export const getListAllRolesRequest = async (data) => {
  const result = await request({
    url: GET_ALL_ROLES,
    method: 'POST',
    data,
  });
  return result?.data?.data?.data;
};

export const getStatusAccountRequest = async (data) => {
  const result = await request({
    url: GET_STATUS_ACCOUNT,
    method: 'POST',
    data,
  });
  return result?.data?.data?.data;
};
